import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';
import { RootState, useDispatch } from '@redux/store';

import { useGetMyProfileQuery } from '@api/user';
import { setErrorMFA } from '@redux/slices/auth';
import { LoadingScreen } from '@components/LoadingScreen';
import { useUserPermissions } from '@hooks/useUserPermissions';
import { Roles } from '@rdTypes/shared';

type RoleBasedGuardProp = {
  accessibleRoles: Roles[];
  children: React.ReactElement;
};

export const RoleBasedGuard = ({ accessibleRoles, children }: RoleBasedGuardProp) => {
  const { data: currentUser } = useGetMyProfileQuery();
  const dispatch = useDispatch();
  const isErrorMFA = useSelector((state: RootState) => state.auth.isErrorMFA);

  if (isErrorMFA && currentUser?.twoFactorEnabled) {
    dispatch(setErrorMFA(false));
  }

  const { isAllowed } = useUserPermissions();

  if (!currentUser) return <LoadingScreen />;

  if (!isAllowed(accessibleRoles)) {
    return <Navigate to="404" />;
  }

  return children;
};
